module.exports = __WEBPACK_EXTERNAL_MODULE_42__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-dropdown"
// module id = 42
// module chunks = 0